import { useQuery } from "react-query";
import useRouteQuery from "../common/useRouteQuery";
import historyRepo from "../../API/LayoutApi/history.repo";

function useHistoryList() {
  const [userId, setUserId] = useRouteQuery("", "user_id", (v) => String(v));
  const [search, setSearch] = useRouteQuery("", "search", (v) => String(v));
  const [page, setPage] = useRouteQuery(1, "page", (v) => Number(v));
  const [isActive, setIsActive] = useRouteQuery("", "is_active", (v) =>
    String(v)
  );

  const { isLoading, isFetching, data, refetch } = useQuery({
    queryKey: ["histories", page, userId, isActive],
    queryFn: () =>
      historyRepo.getHistories({
        page,
        perPage: 10,
        search: search ? search : undefined,
        user_id: userId ? userId : undefined,
        is_active: isActive ? JSON.parse(isActive) : undefined,
      }),
    refetchOnWindowFocus: false,
  });

  return {
    userId,
    setUserId,
    search,
    setSearch,
    page,
    setPage,
    isActive,
    setIsActive,
    isLoading,
    isFetching,
    data,
    refetch,
  };
}

export default useHistoryList;
